import { action } from 'typesafe-actions';
import {
  SELECT_INSPECTION_VIEW_REQUEST,
  SELECT_REQUEST_DETAIL_TAB,
  SET_INSPECTION_VIEW_ACTIVE_PAGE,
  SET_INSPECTION_VIEW_PAGE_SIZE,
  SET_SEARCH_KEYWORD,
} from 'store/analytics/ui/subViews/inspectionView/inspectionViewActionTypes';
import { DetailTabType } from 'store/analytics/ui/analyticsUiTypes';
import { InspectionViewRequest, TxiViewRequest } from 'types/rest/analyticsTypes';
import MixpanelService from 'utils/mixpanelService';
import { SELECTED_REQUEST_DETAIL_TAB } from 'utils/mixpanelEvents';

/**
 * Change active page in the request list.
 * @param tab
 */
export const changeInspectionViewActivePage = (activePage: number) =>
  action(SET_INSPECTION_VIEW_ACTIVE_PAGE, activePage);

/**
 * Update page size.
 * @param pageSize
 */
export const changeInspectionViewPageSize = (pageSize: number) => action(SET_INSPECTION_VIEW_PAGE_SIZE, pageSize);

/**
 * Select request in inspection view.
 * @param pageSize
 */
export const selectInspectionViewRequest = (request: InspectionViewRequest | TxiViewRequest) =>
  action(SELECT_INSPECTION_VIEW_REQUEST, request);

/**
 * Select request in inspection view.
 * @param pageSize
 */
export const setSearchKeyword = (searchKeyword: string) => action(SET_SEARCH_KEYWORD, searchKeyword);

/**
 * Select tab in request detail view
 * @param pageSize
 */
export const selectRequestDetailTab = (tabName: DetailTabType) => {
  MixpanelService.track(SELECTED_REQUEST_DETAIL_TAB(tabName));
  return action(SELECT_REQUEST_DETAIL_TAB, tabName);
};
